import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { DataUploadService } from '../services/data-upload.service';

/**
 * Guards the pipeline routes. If the user hasn't picked any LAS files, redirect
 * to /upload. Otherwise make sure the files are uploaded to the backend
 * (once) before activating the route, so the session is never empty.
 */
export const uploadReadyGuard: CanActivateFn = () => {
  const upload = inject(DataUploadService);
  const router = inject(Router);

  if (!upload.ready()) {
    return router.parseUrl('/upload');
  }

  return upload.ensureUploaded().pipe(
    map(() => true),
    catchError(() => of(router.parseUrl('/upload'))),
  );
};
